<template>
  <div
    v-if="showTooltip"
    ref="tooltip"
    class="mkvue-directive-tooltip">
    <div class="mkvue-directive-tooltip-inner">
      {{ content }}
    </div>
  </div>
</template>

<script>
import { createPopper } from '@popperjs/core';

export default {
  name: 'MTooltipDirectiveContainer',
  props: {
    content: {
      type: String,
      default: null,
    },
    el: {
      type: HTMLButtonElement,
      default: null,
    },
    modifiers: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    showTooltip: false,
    popperInstance: null,
  }),
  watch: {
    showTooltip(val) {
      this.$nextTick(() => {
        if (val) {
          this.resetPopperInstance();
        }
      });
    },
  },
  methods: {
    getPosition() {
      let output = 'top';
      const positionList = ['top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-start', 'bottom', 'bottom-end', 'left-start', 'left', 'left-end'];
      positionList.forEach(position => {
        output = this.modifiers[position] ? position : output;
      });
      return output;
    },
    resetPopperInstance() {
      this.popperInstance = createPopper(this.el, this.$refs.tooltip, {
        placement: this.getPosition(),
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, 8],
            },
          },
        ],
      });
    },
  },
};
</script>


<style lang="scss" scoped>
$prefix: 'mkvue-directive-';
@import "~/node_modules/@mekari/mekari-ui-toolkit/dist/scss/components/tooltip.scss";
</style>
